<template>
    <div class="lx-check" @click="doCheck">
        <div class="check_icon_wrap">
            <span v-if="isCheck" class="icon pre lx-pointer"></span>
            <span v-else class="icon nor lx-pointer"></span>
        </div>
        <slot name="text"></slot>
    </div>
</template>
<script>
export default {
    name: "LxCheck",
    props: {
        isCheck: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    methods: {
        doCheck() {
            this.$emit('change', !this.isChecked)
        }
    }
};
</script>
<style lang="less" scoped>
.lx-check {
    .check_icon_wrap {
        position: relative;
        width: 20px;
        height: 20px;
        overflow: hidden;
        .icon {
            position: absolute;
            top: 0;
            left: 0;
            display: inline-block;
            width: 100%;
            height: 100%;
            background-size: cover;
            &.nor {
                background-image: url("./icon-check-nor.png");
            }
            &.pre {
                background-image: url("./icon-check-pre.png");
            }
        }
    }
}
</style>
